import { Button, Popconfirm, Space } from "antd";
import NoData from "assets/svgs/no_data/NoData";
import React from "react";
import { Placeholder } from "react-bootstrap";
import { DeleteOutlined } from "@ant-design/icons";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useProductMappingStore } from "./store";

function ProductTable({ prodData, isLoading }) {
  const { setToaster } = useToast();
  const { fetchProductData, deleteProductData } = useProductMappingStore();

  const deleteProduct = (key) => {
    deleteProductData(key, setToaster, fetchProductData);
  };

  const header = [
    "Product Id",
    "Principal ID",
    "Medicine Name",
    "Medicine Type",
    "Order Type",
    "Price",
    "Action",
  ];

  return (
    <div>
      <div
        className="mt-1 shadow rounded mt-2 scrollable-container"
        style={{ maxHeight: "70vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top"
          style={{ position: "sticky", top: "0", zIndex: "1" }}
        >
          {header?.map((product) => {
            return (
              <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                {product}
              </span>
            );
          })}
        </div>
        {isLoading ? (
          <>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          </>
        ) : prodData && prodData?.length ? (
          prodData?.map((product, index) => {
            return (
              <div
                className={`d-flex table-row border-1 border-top-0 ${
                  index === prodData?.length - 1 && `rounded-bottom`
                }`}
                key={product?.product_id}
              >
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.product_id}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.principalId}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.medicine_name}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.medicine_type}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.price}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {product?.is_direct_shipping
                    ? "Direct Order"
                    : "Prescription Order"}
                </span>
                <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                  <Popconfirm
                    disabled={product?.group}
                    title={
                      <dev>
                        Are you sure to delete
                        <span className="text-danger ms-2">{product.name}</span> ?
                      </dev>
                    }
                    placement="topRight"
                    onConfirm={() => deleteProduct(product.key)}
                  >
                    <Button
                      disabled={product?.group}
                      icon={<DeleteOutlined />}
                      type="link"
                      danger
                    />
                  </Popconfirm>
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductTable;
